// @ts-nocheck
import _ from 'lodash';
import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box } from '@material-ui/core';
import { useAlert } from '../../../common/hooks';
import { AlertSeverity } from '../../../common/providers';
import { EmptyState, Panel } from '../../../common/components';
import { selectPendingActions } from '../../../common/state/pending';
import TapsList from './partials/TapsList';
import TapsService from '../services/TapsService';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    minHeight: '500px',
  },
}));

function TapsPage() {
  const [t] = useTranslation();
  const { userId } = useParams();
  const { showAlert } = useAlert();
  const classes = useStyles();
  const pendingActions = useSelector(selectPendingActions);
  const [ removed, setRemoved ] = useState<Array<string>>([]);

  const { data: taps } = useQuery(['taps', userId], async () => {
    const { data } = await TapsService.fetchTaps(userId);
    if(removed.length && data?.permissions.length) {
      data.permissions.forEach(perm => {
        if(!perm.discardedDate && removed.indexOf(perm.consentType) !== -1)
          setRemoved(removed.filter(remove => remove !== perm.consentType));
      });
    }

    return data;
  });

  const queryClient = useQueryClient();
  const cancelTaps = useMutation(
    async ({ userId, consents }: { userId: string; consents: Array<string> }) => {
      consents.forEach(async consent => {
        await TapsService.clearTaps(userId, consent);
        const perm = taps.permissions.find(perm => perm.consentType === consent);
        if(perm)
          setRemoved([...removed, perm.consentType]);
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['taps', userId]);
        showAlert({
          title: t('common.success'),
          message: t('taps.tapsClearSuccess'),
          severity: AlertSeverity.Success,
        });
      },
      onError: (e: Error) => {
        showAlert({
          title: t('taps.tapsClearError'),
          message: e.message,
          severity: AlertSeverity.Error,
        });
      },
    }
  );

  const handleClearTaps = useCallback(
    async (consents: Array<string>) => {
      await cancelTaps.mutate({
        userId,
        consents
      });
    },
    [cancelTaps, userId]
  );

  return (
    <Box id="Taps-container" className={classes.container}>
      <Panel id="Taps-panel" variant="contained">
        {!taps ? (
          <EmptyState variant="unavailable" message={t('taps.tapsEmpty')} />
        ) : (
          <TapsList
            data={taps}
            removed={removed}
            onClearTaps={handleClearTaps}
            actionsDisabled={!_.isEmpty(pendingActions)}
          />
        )}
      </Panel>
    </Box>
  );
}

export default TapsPage;
